export const REGEX_FOR_ISO_CALENDAR_DAY_KEY = /^\d{4}-\d{2}-\d{2}$/

export const REGEX_OF_DECIMAL_PHONE = /^\d{11}$/
export const REGEX_FOR_CHECK_PHONE
  = /^(?:\+7|7|8)?\s?\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{2}[\s-]?\d{2}$/
export const REGEX_FOR_MASK_PHONE = /^\+7\s\(\d{3}\)-\d{3}-\d{2}-\d{2}$/
export const REGEX_FOR_CHECK_EMAIL = /^[\w.%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/
export const REGEX_FOR_PASSWORD
  = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,}$/
export const REGEX_FOR_CYRILLIC = /^[\p{Script=Cyrillic}\s\-]+$/u
export const REGEX_FOR_TEXT_WITHOUT_LATIN = /^[^a-z]+$/i
